import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { renderQuestionInput } from '../renderQuestionInput';
import ProgressBar from './ProgressBar';
import './QuestionnairePage.css'; 

export default function QuestionnairePage() {
  const { categoryId } = useParams();
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const categoryNames = {
    1: 'Ekonomski razvoj',
    2: 'Upravljanje',
    3: 'Ekologija',
    4: 'Inovacije i pametni gradovi',
  };
  const title = categoryNames[categoryId] || 'Upitnik';

  useEffect(() => {
    const checkProfileCompletion = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('https://nagradjivanje-api.revicon.info/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });
        const profile = res.data;
        if (!profile.completed) {
          alert('Prvo morate popuniti profil!');
          navigate('/profile');
        }
      } catch (err) {
        alert('Greška pri provjeri profila.');
        navigate('/profile');
      }
    };

    checkProfileCompletion();
  }, [navigate]);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`https://nagradjivanje-api.revicon.info/questionnaire/${categoryId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
const qList = res.data;
const prefilled = {};

qList.forEach((q) => {
  if (q.selected_answer_id !== null && q.selected_answer_id !== undefined) {
    prefilled[q.id] = String(q.selected_answer_id);
  }

  if (q.selected_raw_value !== null && q.selected_raw_value !== undefined && q.selected_raw_value !== '') {
    if (q.type === 'multi_checkbox') {
      if (Array.isArray(q.selected_raw_value)) {
        prefilled[q.id] = q.selected_raw_value.map(String);
      } else {
        try {
          const parsed = JSON.parse(q.selected_raw_value);
          prefilled[q.id] = Array.isArray(parsed)
            ? parsed.map(String)
            : [];
        } catch {
          prefilled[q.id] = String(q.selected_raw_value)
            .split(',')
            .map((x) => x.trim())
            .filter(Boolean)
            .map(String);
        }
      }
    } else {
      prefilled[q.id] = String(q.selected_raw_value);
    }
  }
});

setAnswers(prefilled);
setQuestions(qList);
      } catch {
        alert('Greška prilikom dohvata pitanja.');
      } finally {
        setLoading(false);
      }
    };
    fetchQuestions();
  }, [categoryId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
const formatted = questions
  .map((q) => {
    const value = answers[q.id];

    if (value === undefined || value === null || value === '') {
      return null;
    }

    if (q.type === 'multi_checkbox') {
      return {
        question_id: q.id,
        raw_value: JSON.stringify(Array.isArray(value) ? value.map(String) : [])
      };
    }

    const shouldUseRaw = [
      'boolean',
      'boolean_bonus',
      'boolean_combo',
      'boolean_info',
      'numeric_integer',
      'numeric_percent',
      'numeric_decimal',
      'text_score_description',
      'text_info',
      'select_combo_incident'
    ].includes(q.type);

    if (shouldUseRaw) {
      return {
        question_id: q.id,
        raw_value: String(value)
      };
    }

    return {
      question_id: q.id,
      answer_id: parseInt(value, 10)
    };
  })
  .filter(Boolean);

      await axios.post(
        `https://nagradjivanje-api.revicon.info/questionnaire/${categoryId}/submit`,
        { answers: formatted },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const nextCategory = parseInt(categoryId) + 1;
      if (nextCategory <= 4) {
        navigate(`/questionnaire/${nextCategory}`);
      } else {
        navigate(`/thank-you`);
      }
    } catch (err) {
      alert('Greška prilikom slanja odgovora.');
    }
  };

  if (loading) return <p>Učitavanje...</p>;

  const handleInput = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

return (
  <div className="layout">
    <main className="content-area">
      <div className="form-container">
        <div className="questionnaire-card">
          <h2>{title}</h2>

          <form onSubmit={handleSubmit}>
            {questions.map((q, index) => (
              <div key={q.id} className="question-block">
                <p className="question-text">{index + 1}. {q.text}</p>
                <div className="question-input">{renderQuestionInput(q, answers[q.id], handleInput)}</div>
                <hr className="question-divider" />
              </div>
            ))}

            <div className="submit-container">
              <button type="submit">Pređi na drugu kategoriju</button>
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
);


}
